import { render, staticRenderFns } from "./PreventUnsavedChangesModal.vue?vue&type=template&id=d57fe80a&scoped=true&"
import script from "./PreventUnsavedChangesModal.vue?vue&type=script&lang=ts&"
export * from "./PreventUnsavedChangesModal.vue?vue&type=script&lang=ts&"
import style0 from "./PreventUnsavedChangesModal.vue?vue&type=style&index=0&id=d57fe80a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57fe80a",
  null
  
)

export default component.exports